import styled from 'styled-components';

export const HighchartsWrapper = styled.div`
  width: 100%;
  height: 100%;
  float: left;

  .highcharts-plot-line {
    cursor: pointer;
  }

  .theme-light & .group-by-legend-percentage {
    color: #596468;
  }

  .theme-dark & .group-by-legend-percentage {
    color: #c0c5c7;
  }
`;

export const CustomLegendWrapper = styled.div`
  width: 25%;
  float: left;
`;
